import { useLocation } from "react-router-dom";
import { MODAL_ROUTES } from "routing/routes";

import { ContextMenuLink, Icon, Text } from "@seneca/senekit";

type Props = {
  onClick?: () => void;
};

export default function DarkModeGatingMenuOption({ onClick }: Props) {
  const location = useLocation();

  return (
    <ContextMenuLink
      to={{
        pathname: MODAL_ROUTES.UNLOCK_DARK_MODE.buildPath({}),
        state: MODAL_ROUTES.UNLOCK_DARK_MODE.buildState({
          background: location
        })
      }}
      onClick={onClick}
    >
      {{
        icon: (
          <Icon
            iconName="lock"
            size="medium"
            accessibilityLabel={null}
            tone="neutral"
          />
        ),
        text: <Text>Dark mode</Text>
      }}
    </ContextMenuLink>
  );
}
